import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@drdropin-tech/theseus';
export default function RightArrowButton({ text, onClick }) {
    return (_jsxs("button", { className: "mb-8 flex w-full items-center justify-between", onClick: onClick, children: [_jsx("span", { children: text }), _jsx("div", { className: "text-primary hover:bg-accent rounded-full bg-white p-1", children: _jsx(Icon, { name: "ArrowRight" }) })] }));
}
